import _styled from "styled-components";
import { useEffect } from "react";
import { useIsClient } from "@crehana/react-hooks";
import cn from "clsx";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from "styled-components";
import { useMainMenuContext, useScreenLgBreakpoint } from "../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var SubmenuBackdrop = function SubmenuBackdrop() {
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme,
    isTransparent = _useMainMenuContext.isTransparent,
    activeSubMenu = _useMainMenuContext.activeSubMenu,
    currentBreakpointKey = _useMainMenuContext.currentBreakpointKey,
    mainMenuVisibleHeight = _useMainMenuContext.mainMenuVisibleHeight,
    topBannerVisibleHeight = _useMainMenuContext.topBannerVisibleHeight,
    onChangeStateOpenOverlay = _useMainMenuContext.onChangeStateOpenOverlay;
  var isClient = useIsClient();
  var _useScreenLgBreakpoin = useScreenLgBreakpoint(),
    isLg = _useScreenLgBreakpoin.isLg,
    isEmbeddedInNewDashboard = _useScreenLgBreakpoin.isEmbeddedInNewDashboard;
  var submenuIsOpen = activeSubMenu === 'catalog-menu' || activeSubMenu === 'solutions-menu' || activeSubMenu === 'degrees-menu' || activeSubMenu === 'left-menu-drawer' || activeSubMenu === 'notifications-drawer' || activeSubMenu === 'user-menu' && currentBreakpointKey === 'sm';

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (onChangeStateOpenOverlay) {
      onChangeStateOpenOverlay('CoursesExplorer', submenuIsOpen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submenuIsOpen]);
  if (!isClient || currentBreakpointKey === 'xs') {
    return null;
  }
  var dynamicTopSpaceDependingOnTransparencyLg = isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.lg;
  var dynamicTopSpaceDependingOnBreakpointMd = isLg && isEmbeddedInNewDashboard ? dynamicTopSpaceDependingOnTransparencyLg : 0;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    className: cn('fixed inset-0 pointer-events-none', theme.submenu.backdropColorClassName, submenuIsOpen ? 'cui-is-visible' : 'cui-is-hidden', {
      'pointer-events-none': !submenuIsOpen
    }),
    $_css: theme.nav.zIndex - 1,
    $_css2: isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.xs,
    $_css3: dynamicTopSpaceDependingOnBreakpointMd,
    $_css4: isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.lg
  });
};
export default SubmenuBackdrop;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-16mzy5r-0"
})(["\n        backdrop-filter: blur(4px);\n        -webkit-backdrop-filter: blur(4px);\n        z-index: ", ";\n        top: ", "px;\n\n        ", " {\n          top: 0;\n        }\n\n        ", " {\n          top: ", "px;\n        }\n\n        ", " {\n          top: ", "px;\n        }\n      "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (props) {
  return props.theme.breakpoints.up('sm');
}, function (props) {
  return props.theme.breakpoints.up('md');
}, function (p) {
  return p.$_css3;
}, function (props) {
  return props.theme.breakpoints.up('lg');
}, function (p) {
  return p.$_css4;
});